
import { Component, Vue } from 'vue-property-decorator';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateDNSRecordForm from '@/services/DNS/forms/CreateDNSRecordForm';
import DNSRepositoryInterface, { CAARecord, DNSZonesInterface } from '@/services/DNS/Interfaces';
import {
  DNSRecord,
  DNSRecordFactory, TXTRecord,
} from '@fenix/dns-entities';

@Component({
  inject: [
    'dnsRepository',
  ],
})
export default class CreateDns extends Vue {
  public readonly dnsRepository!: DNSRepositoryInterface;

  public loading: boolean = true;

  public form: WPXFormValue<CreateDNSRecordForm> = new WPXFormValue<CreateDNSRecordForm>(CreateDNSRecordForm);
  public dnsZone: DNSZonesInterface = {} as DNSZonesInterface;

  public async created(): Promise<void> {
    this.dnsZone = await this.dnsRepository.getZones(this.$route.params.id);

    this.loading = false;
  }


  public async addDnsRecord(): Promise<void> {
    const formData = JSON.parse(JSON.stringify(this.form.data));
    let record: DNSRecord;
    console.log(formData);
    const host = this.buildRecordHost(formData.host, this.dnsZone.installation.domain);
    if (formData.type === "CAA") { // One day we deserve better...
      record = new CAARecord(
        formData.caaTag,
        formData.id,
        host,
        Number(formData.ttl),
        formData.target,
        formData.caaFlags,
      );
    } else {
      [, record] = await DNSRecordFactory.generateRecord(Object.assign(formData, {
        host: host,
      }));
    }

    try {
      await this.dnsRepository.createDNSRecord(this.dnsZone.id, record);
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  public backToZone(): void {
    this.$router.push({ name: 'dns_zone_view' });
  }

  private buildRecordHost(hostInput: string, domainInput: string): string {
    const host = (hostInput || '').trim().toLowerCase();
    const domain = domainInput.trim().toLowerCase();

    if (!host || host === '@' || host === domain) {
      return domain;
    }

    if (host.endsWith(`.${domain}`)) {
      return host;
    }

    return `${host}.${domain}`;
  }
}
